import appGlobalScript from '/builds/design-system/design-system/web-components/ontario-design-system-components/packages/ontario-design-system-component-library/src/global.ts';
export const globalScripts = appGlobalScript;
